import React from "react";
import propTypes from 'prop-types'
import { Checkbox, Dropdown, Flowbite } from "flowbite-react";
import { dropDown } from "../../../theme/flowbite.custom.theme";

export const MultiSelectComponent = React.memo(({ options, handleChange, loader, numberofItemsShown, placeHolderText, className }) => {

    const getLabel = () => {
        const selected = options?.length && options?.filter(option => option?.checked)?.map(option => option?.name);
        return <>
            <span className={`truncate${numberofItemsShown < 2 ? 'max-w-200' : 'max-w-lg'}  ${selected?.length ? 'text-secondary-500' : ''}`}>
                {loader ? "Loading..." : (selected?.length && selected?.splice(0, numberofItemsShown).join(', ')) || placeHolderText}</span>
            {(options?.length > 2 && selected?.length) > 0 && <span className="bg-primary-50 text-secondary-500 p-1">{`+${(selected?.length) > 0 ? selected?.length : ""} `} </span>}
        </>
    }

    return (
        <Flowbite theme={{ theme: dropDown }}>
            <Dropdown
                inline
                label={getLabel()}
                disabled={loader}
                dismissOnClick={false}
                isOpen={true}
                className={`border border-secondary-200  `}>
                {!!options?.length
                    && options?.map((option, subIndex) => <Dropdown.Item className={`block mr-0 text-start gap-4 truncate max-w-sm`} key={option?.name} role="button" onClick={() => handleChange(option, subIndex)}>
                        <Checkbox value={option?.checked} readOnly checked={option?.checked} />   <span className="mx-2 leading-15">{option?.name}</span>
                    </Dropdown.Item>)}
            </Dropdown>
        </Flowbite>
    );
});

MultiSelectComponent.propTypes = {
    options: propTypes.array,
    handleChange: propTypes.func,
    loader: propTypes.bool,
    numberofItemsShown: propTypes.number,
    placeHolderText: propTypes.string,
    className: propTypes.string,
}

MultiSelectComponent.defaultProps = {
    options: [],
    handleChange: () => null,
    loader: false,
    numberofItemsShown: 2,
    placeHolderText: "Click to select reportees",
    className: ""
}
